var __jsx = React.createElement;
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
// https://docs.developers.optimizely.com/full-stack/docs/javascript-client-side-implementation#section-datafile-management-for-javascript-client-side-implementation
export var OptimizelyScript = function OptimizelyScript(_ref) {
  var withKey = _ref.withKey;
  return /*#__PURE__*/_jsx("script", {
    src: "https://cdn.optimizely.com/datafiles/".concat(withKey, ".json/tag.js")
  });
};